export const CONVERSATIONAL_CLOUD_TEST_ACCOUNT_ID = '60195211';
export const CONVERSATIONAL_CLOUD_PROD_ACCOUNT_ID = '79835795';
